var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/containers.scss';
import React, { forwardRef } from 'react';
import { Padding, Spacing } from '@front/sharedcomponents/Variables';
export const Stack = forwardRef((_a, ref) => {
    var { className, direction = 'row', justify = 'flex-start', align = 'flex-start', wrap = 'nowrap', padding = Padding.None, spacing = Spacing.Medium, style = {}, children } = _a, otherProps = __rest(_a, ["className", "direction", "justify", "align", "wrap", "padding", "spacing", "style", "children"]);
    const flexStyle = Object.assign({ display: 'flex', flexDirection: direction, justifyContent: justify, alignItems: align, flexWrap: wrap }, style);
    const containerClasses = [className, padding, spacing].filter(Boolean).join(' ');
    return (React.createElement("div", Object.assign({ ref: ref, className: containerClasses, style: flexStyle }, otherProps), children));
});
